export enum EMAIL_CREDENTIALS_AUTH_MODE {
    signIn = 'signIn',
    signUp = 'signUp',
}
